// eslint-disable-next-line no-template-curly-in-string
export const TYPE_TEMPLATE = '${type}';
// eslint-disable-next-line no-template-curly-in-string
export const OFFSET_TEMPLATE = '${offset}';
// eslint-disable-next-line no-template-curly-in-string
export const LIMIT_TEMPLATE = '${limit}';
// eslint-disable-next-line no-template-curly-in-string,max-len
export const NEWS_PAGE_ENDPOINT_TEMPLATE = [
    `/services/api/search/filtering?type=${TYPE_TEMPLATE}`,
    `offset=${OFFSET_TEMPLATE}`,
    `limit=${LIMIT_TEMPLATE}`,
].join('&');
export var LIMIT_PER_PAGE;
(function (LIMIT_PER_PAGE) {
    LIMIT_PER_PAGE[LIMIT_PER_PAGE["limitDesktop"] = 18] = "limitDesktop";
    LIMIT_PER_PAGE[LIMIT_PER_PAGE["limitTablet"] = 12] = "limitTablet";
    LIMIT_PER_PAGE[LIMIT_PER_PAGE["limitMobile"] = 6] = "limitMobile";
})(LIMIT_PER_PAGE || (LIMIT_PER_PAGE = {}));
export const Y_OFFSET_FOR_PAGINATION = 175;
export var PARAMS_KEYS;
(function (PARAMS_KEYS) {
    PARAMS_KEYS["years"] = "years";
    PARAMS_KEYS["page"] = "page";
    PARAMS_KEYS["categories"] = "categories";
})(PARAMS_KEYS || (PARAMS_KEYS = {}));
export const NEWS_TYPE = 'news';
export const EVENTS_TYPE = 'events';
export const NEWS_EVENTS_GRID_TEST_ID = 'news-events_grid';
export const INFINITE_SCROLL_OFFSET_DESKTOP = '-100px';
export const INFINITE_SCROLL_OFFSET_MOBILE = '-75px';
export const DEFAULT_PAGE_SEARCH_INFINITE_SCROLL = '?';
export const DEFAULT_PAGE_SEARCH_PAGINATION = '?page=1';
